import { Spin } from 'antd';
import styles from './index.module.sass';
import { useEffect, useRef, useState } from 'react';
//import { map } from '@/widgets/storage-viewer/map';
import { pointsMap as map } from './map.model';
import { useStore } from 'effector-react';
import { removeTrailingComma } from '@/modules/seller-account/functions/remove-trailing-comma.function';
import { HangarPoint } from './components/hangar-point';
import { PointModal } from './components/point-modal';
import { IReceivingPoint } from '@/modules/seller-account/ts';
import { $buyerPointsLoadingStatus } from '@/modules/buyer-account/store/points.store';
import { $addressOptions, $pointAddress, resetPointAddress, setPointAddress } from '@/modules/seller-account/store/buyers.store';


export const PointsTab = ({
  buyerId,
  modalVisible,
  setModalVisible,
  data,
  description,
  customDeleteFoo,
  customSwitchFoo,
  customCreateFoo,
  customUpdateFoo,
  loadingStatus,
  pointsNotEditable
}: {
  buyerId: number;
  modalVisible: boolean;
  setModalVisible: (val: boolean) => void;
  data: any;
  description?: string;
  loadingStatus: { loading: boolean, error: string | any },
  customDeleteFoo?: (id: number) => Promise<unknown>,
  customSwitchFoo?: (id: number, enabled: 1 | 0) => Promise<unknown>,
  customCreateFoo?: (dto: any) => Promise<unknown>,
  customUpdateFoo?: (dto: any) => Promise<unknown>,
  pointsNotEditable?: boolean,
}) => {
  //const data = useStore($selectedBuyerReceivingPoints);

  const [addressString, setAddressString] = useState('');
  const [nameString, setNameString] = useState('');
  const [hasMixer, setHasMixer] = useState(0);
  const [pointForEditId, setPointForEditId] = useState(-1);
  const [viewMode, setViewMode] = useState(false);
  const [initialized, setInitialized] = useState(0);

  let animationFrame: number = 0;
  const containerDomRef = useRef<any>(null);
  const observerRef = useRef(
    new ResizeObserver(() => {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
      }
      animationFrame = window.requestAnimationFrame(() => {
        map.resize();
      });
    }),
  );

  const pointName = useStore($pointAddress);
  const addressOptions: any = useStore($addressOptions);

  useEffect(() => {
    if (containerDomRef.current) {
      ymaps.ready(() => {
        map.dispose();
        map.init('yviewer', containerDomRef.current);
        !viewMode && map.initClickEvent(setPointAddress as any, pointName);
        viewMode && map.setZoomToView();
        map.setViewMode('hybrid');
        // viewMode ? map.setViewMode('satellite') : map.setViewMode('hybrid');
        //setMapInitialized(true);
      });

      if (containerDomRef.current) {
        observerRef.current.observe(containerDomRef.current);
      }

      return () => {
        map.dispose();
        observerRef.current.disconnect();
      };
    }
  }, [modalVisible]);

  useEffect(() => {
    // if (pointForEditId > 0) {
    //   setNameString(pointName.name || '' );
    // }
    setAddressString(
      removeTrailingComma(
        `${pointName.country ? pointName.country + ',' : ''} ${
          pointName.region ? pointName.region + ',' : ''
        } ${pointName.area ? pointName.area + ',' : ''} ${
          pointName.street ? pointName.street + (pointName.house !== '' ? ',' : '') : ''
        } ${pointName.house || ''}`,
      ),
    );
  }, [pointName]);

  useEffect(() => {
    modalVisible && setNameString(!pointName.name ? '' : pointName.name);
    console.log(pointName)
    modalVisible && setHasMixer(pointName.has_mixer || 0)
    setAddressString(addressString.trim());
    setInitialized(0);
  }, [modalVisible]);

  const checkIsLastEnabled = (data: any) => {
    const res = data?.reduce(
      (acc: number, item: any) => (item.enabled === 1 ? acc + 1 : acc),
      0,
    );
    return res === 1 ? true : false;
  };

  checkIsLastEnabled(data);
  return (
    <>
      <PointModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        viewMode={viewMode}
        setViewMode={setViewMode}
        addressString={addressString}
        setAddressString={setAddressString}
        hasMixer={hasMixer}
        setHasMixer={setHasMixer}
        nameString={nameString}
        setNameString={setNameString}
        setPointForEditId={setPointForEditId}
        pointForEditId={pointForEditId}
        pointName={pointName}
        buyerId={buyerId}
        addressOptions={addressOptions}
        containerDomRef={containerDomRef}
        data={data}
        customCreateFoo={customCreateFoo}
        customUpdateFoo={customUpdateFoo}
      />

      <div className={styles.root}>
        <span className={styles.heading}>адрес пункта приема зерна*</span>
        <span className={styles.description}>
          {description || (
            <>
              Пункты приема зерна позволяют указать адреса, на которые будет
              осуществляться доставка зерна. <br />
              Добавленные пункты приема участвуют в расчете логистических цепочек и
              итоговой стоимости зерна.
            </>
          )}
        </span>
        <div className={styles.pointsWrap}>
          {loadingStatus.loading && <Spin className={styles.loader} />}
          {data &&
            !loadingStatus.loading &&
            !loadingStatus.error &&
            data.map((item: IReceivingPoint, i: number) => (
              <HangarPoint
                setPointForEditId={setPointForEditId}
                buyerId={item.buyerable_id}
                key={i}
                id={item.id}
                region={item.region}
                city={item.city}
                street={item.street}
                build={item.house}
                setModalVisible={setModalVisible}
                setAddressString={setAddressString}
                enabled={item.enabled || 0}
                hasMixer={item.has_mixer}
                name={item.name}
                switchToView={() => setViewMode(true)}
                coordinates={item.coordinates}
                isLastEnabled={checkIsLastEnabled(data)}
                customSwitchFoo={customSwitchFoo}
                customDeleteFoo={customDeleteFoo}
                pointsNotEditable={pointsNotEditable}
              />
            ))}
          { !pointsNotEditable && <AddPointButton
            onClick={() => {
              setPointForEditId(-1);
              setModalVisible(true);
            }}
            setAddressString={setAddressString}
          />}
        </div>
      </div>
    </>
  );
};

const AddPointButton = ({
  onClick,
  setAddressString,
}: {
  onClick: () => void;
  setAddressString: (val: string) => void;
}) => (
  <a
    href="#"
    className={styles.addPointButton}
    onClick={(e) => {
      setAddressString('');
      resetPointAddress();
      e.preventDefault();
      onClick();
    }}
  >
    добавить <br /> новый адрес
  </a>
);
